import qs from "qs";

export type LinkedinParams = {
  url: string;
};

interface LinkedinButtonProps {
  params: LinkedinParams;
  className?: string;
  children: React.ReactNode;
}

const DEFAULT_POPUP_OPTIONS = {
  height: 600,
  width: 750,
  location: "no",
  toolbar: "no",
  status: "no",
  directories: "no",
  menubar: "no",
  scrollbars: "yes",
  resizable: "no",
  centerscreen: "yes",
  chrome: "yes",
};

const popupStyles = Object.entries(DEFAULT_POPUP_OPTIONS)
  .map(([key, value]) => `${key}=${value}`)
  .join(",");

export const LinkedinButton = ({
  params,
  className,
  children,
}: LinkedinButtonProps) => {
  const handleClick = () => {
    const url = `https://www.linkedin.com/sharing/share-offsite?${qs.stringify(
      params
    )}`;
    window.open(url, "", popupStyles);
  };

  return (
    <button
      type="button"
      aria-label="Linked-in"
      onClick={handleClick}
      className={className}
      css={`
        text-align: left;
        color: inherit;
        background-color: transparent;
        border: none;
      `}
    >
      {children}
    </button>
  );
};
